import { render } from "./HomePeriod.vue?vue&type=template&id=23138b74"
import script from "./HomePeriod.vue?vue&type=script&lang=js"
export * from "./HomePeriod.vue?vue&type=script&lang=js"

import "./HomePeriod.vue?vue&type=style&index=0&id=23138b74&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__